<template>
    <div class="modal-content fm-modal-preview">
        <div class="modal-header">
          <h5 class="modal-title w-75 text-truncate">
              Formulaire : {{ selectedItem.basename }}
          </h5>
          <button type="button" class="close" aria-label="Close" v-on:click="hideModal">
              <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center pl-5 pr-1">
          <file-detail/>
        </div>
    </div>
</template>

<script>
import modal from '../mixins/modal';
import helper from '../../../router/mixins/helper';
import FileDetail from '../../../components/details/FileDetail';

export default {
  name: 'FormPreview',
  mixins: [modal, helper],
  components: { FileDetail },
  data() {
    return {
      pdfLink: '',
    };
  },
  created() {
    this.setPdfLink();
  },
  computed: {
    /**
     * Authorization required
     * @return {*}
     */
    auth() {
      return this.$store.getters['settings/authHeader'];
    },

    /**
     * Selected disk
     * @returns {*}
     */
    selectedDisk() {
      return this.$store.getters['selectedDisk'];
    },

    /**
     * Selected file
     * @returns {*}
     */
    selectedItem() {
      return this.$store.getters['selectedItems'][0];
    },

    /**
     * Calculate the max height for image
     * @returns {number}
     */
    maxHeight() {
      // if (this.$store.state.modal.modalBlockHeight) {
      //   return this.$store.state.modal.modalBlockHeight - 170;
      // }
      return 100;
    },
  },
  methods: {
    /**
     * Set the Pdf file encoded Url
     * 
     * Author: Kevin OLENGA
     */
    setPdfLink() {
      this.pdfLink = `${this.$store.getters['settings/baseUrl']}download?disk=${this.selectedDisk}&path=${encodeURIComponent(this.selectedItem.path)}`;
    },
  },
};
</script>

<style lang="scss">
    .fm-modal-preview {

        .modal-body {
            padding-bottom: 40px;

            img {
                max-width: 100%;
            }
        }

        & > .d-flex {
            padding: 1rem;
            border-top: 1px solid #e9ecef;
        }
    }

    .loader {
      border: 6px solid #f3f3f3;
      border-radius: 50%;
      border-top: 6px solid #3498db;
      // border-bottom: 6px solid #3498db;
      width: 36px;
      height: 36px;
      -webkit-animation: spin 2s linear infinite; /* Safari */
      animation: spin 1s linear infinite;
    }

    /* Safari */
    @-webkit-keyframes spin {
      0% { -webkit-transform: rotate(0deg); }
      100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
</style>
